
import {
  Vue, Component, Watch,
} from 'vue-property-decorator';
import { User, PermissionCode, Network } from './types';

@Component({
  sockets: {
    connect() {
      console.log('socket connected'); // eslint-disable-line no-console
    },
  },
})
export default class App extends Vue {
  drawer = false

  async created() {
    console.log('App: created()'); // eslint-disable-line no-console

    // Se è specificato un brand nella query string, lo applico
    if (this.$route.query.brand !== undefined) {
      console.log(`App: created() - brand = ${this.$route.query.brand}`); // eslint-disable-line no-console
      this.applyBrand(this.$route.query.brand as string);
    }
  }

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get userPermissions(): PermissionCode[] {
    return this.$store.getters.currentUserPermissions;
  }

  get userNetwork(): Network {
    return this.$store.getters.currentUserNetwork;
  }

  get brand(): string {
    return this.userNetwork.shortname ?? 'syndesia';
  }

  get logo(): string | null {
    return this.$store.getters.logo;
  }

  // Logo dell'app bar: versione bianca senza payoff, leggibile sulla barra alta 48px.
  // Esiste solo per Syndesia; per gli altri brand l'app bar resta testuale.
  get brandLogo(): string | null {
    if (this.brand !== 'syndesia') return null;

    // eslint-disable-next-line global-require, import/no-unresolved
    return require('@/assets/img/syndesia-logo-white.svg');
  }

  get title(): string {
    return this.$store.getters.title;
  }

  @Watch('user')
  onUserChanged(val: User | null, oldVal: User | null) {
    if (val && !oldVal) {
      console.log('App: watch.user() logged-in'); // eslint-disable-line no-console

      // eslint-disable-next-line no-underscore-dangle
      this.$socket.open();

      this.$store.dispatch('initCategories');
      this.$store.dispatch('initTags');
      this.$store.dispatch('initNetworks');
      this.$store.dispatch('initUsers');
      this.$store.dispatch('initAttachmentsDetails');
      // Integrazioni esterne: finche' non risponde restano tutte spente, quindi
      // i punti d'ingresso non compaiono per poi sparire.
      this.$store.dispatch('fetchIntegrations');

      this.applyBrand();
    } else if (!val && oldVal) {
      console.log('App: watch.user() logged-out'); // eslint-disable-line no-console

      // eslint-disable-next-line no-underscore-dangle
      this.$socket.close();
    }
  }

  async applyBrand(brand?: string) {
    console.log('App: applyBrand()'); // eslint-disable-line no-console

    await this.$store.dispatch('updateUserNetwork', { shortname: brand ?? this.brand });
    document.title = process.env.VUE_APP_ENV === 'production'
      ? this.title
      : `${this.title} (${process.env.VUE_APP_ENV})`;
  }

  hasPermission(codename: PermissionCode) {
    // console.log(`App: hasPermission(${codename})`); // eslint-disable-line no-console

    if (!this.user) return false;
    if (this.user.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }

  logout() {
    console.log('App: logout()'); // eslint-disable-line no-console

    // Se l'utente è loggato con un brand diverso da 'syndesia', lo salvo
    // (altrimenti lo perdo dopo il logout).
    const currentBrand = this.brand !== 'syndesia' ? this.brand : undefined;

    // Effettuo il logout
    this.$store.dispatch('logout')
      .then(() => {
        console.log('App: logout() - logout riuscito'); // eslint-disable-line no-console

        // Rimando alla pagina di login
        this.$router.replace({
          name: 'Login',
        },
        // Dopo il logout, se l'utente era loggato con un brand diverso da 'syndesia',
        // lo ripristino.
        () => {
          if (currentBrand) this.applyBrand(currentBrand);
        });
      });
  }
}
